
import Vue from 'vue'
import { cid } from 'is-ipfs'
import Swal from 'sweetalert2'
import { ParsedQuery } from 'query-string'

export default Vue.extend({
  data: () => ({
    cid: '',
    filename: ''
  }),

  methods: {
    /**
     * User wants to open a CID
     */
    open() {
      if (!cid(this.cid)) {
        return Swal.fire({
          title: 'CID invalid',
          html: 'Please enter a valid IPFS CID.',
          icon: 'warning'
        })
      }

      const query: ParsedQuery = {
        cid: this.cid,
        name: this.filename
      }

      // Reload the page to get better results
      this.$router.push({
        path: '/explorer',
        query
      })
    }
  }
})
